import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import AreaBase from '../_internal/areabase';
import ColumnDataset from '../../dataset/column';
import AreaDataset from '../../dataset/area';
import LineDataset from '../../dataset/line';
import SplineAreaDataset from '../../dataset/mssplinearea';
import SplineLineDataset from '../../dataset/msspline';
import ColumnMultiSeriesGroup from '../../dataset/groups/column-multiseries';
import datasetFactory from '../../factories/combi-dual-y-dataset';
var UNDEFINED;

var MSCombi2D =
/*#__PURE__*/
function (_AreaBase) {
  _inherits(MSCombi2D, _AreaBase);

  function MSCombi2D() {
    var _this;

    _classCallCheck(this, MSCombi2D);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MSCombi2D).call(this)), _this.registerFactory('dataset', datasetFactory, ['vCanvas']);
    return _this;
  }

  _createClass(MSCombi2D, [{
    key: "getName",
    value: function getName() {
      return 'MSCombi2D';
    }
  }, {
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      _get(_getPrototypeOf(MSCombi2D.prototype), "__setDefaultConfig", this).call(this);

      var a = this.config;
      a.friendlyName = 'Multi-series Combination Chart', a.defaultDatasetType = 'column', a.enablemousetracking = !0, a.showzeroplaneontop = 0;
    }
  }, {
    key: "getDSdef",
    value: function getDSdef(a) {
      if ('splinearea' === a) return SplineAreaDataset;
      return 'spline' === a ? SplineLineDataset : 'area' === a ? AreaDataset : 'line' === a ? LineDataset : ColumnDataset;
    }
  }, {
    key: "getDSGroupdef",
    value: function getDSGroupdef(a) {
      return 'column' === a ? ColumnMultiSeriesGroup : UNDEFINED;
    }
  }, {
    key: "getDSType",
    value: function getDSType() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if ('splinearea' === a.toLowerCase()) return 'splinearea';
      return 'spline' === a.toLowerCase() ? 'spline' : 'area' === a.toLowerCase() ? 'area' : 'line' === a.toLowerCase() ? 'line' : 'column';
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'MSCombi2D';
    }
  }]);

  return MSCombi2D;
}(AreaBase);

export default MSCombi2D;